var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCompanyAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1122_50589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.9762 43.8831V10.3751C81.9762 8.59769 81.2888 6.89311 80.065 5.63632C78.8413 4.37952 77.1816 3.67346 75.451 3.67346H10.1986C8.46798 3.67346 6.80826 4.37952 5.58454 5.63632C4.36082 6.89311 3.67334 8.59769 3.67334 10.3751V77.3911C3.67334 79.1684 4.36082 80.873 5.58454 82.1298C6.80826 83.3866 8.46798 84.0927 10.1986 84.0927H42.8248M75.5597 63.9879V86.3265M86.3264 75.0455H64.5756",
    stroke: "url(#paint0_linear_1122_50589)",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3675 29.928V25.066C33.3675 23.7766 33.8835 22.5399 34.802 21.6281C35.7206 20.7163 36.9664 20.2041 38.2654 20.2041H48.0613C49.3604 20.2041 50.6062 20.7163 51.5247 21.6281C52.4433 22.5399 52.9593 23.7766 52.9593 25.066V29.928M43.1634 42.0829V42.1072M21.1226 34.7899C21.1226 33.5005 21.6386 32.2638 22.5571 31.352C23.4757 30.4402 24.7215 29.928 26.0205 29.928H60.3062C61.6053 29.928 62.8511 30.4402 63.7696 31.352C64.6882 32.2638 65.2042 33.5005 65.2042 34.7899V56.6687C65.2042 57.9582 64.6882 59.1948 63.7696 60.1066C62.8511 61.0184 61.6053 61.5306 60.3062 61.5306H26.0205C24.7215 61.5306 23.4757 61.0184 22.5571 60.1066C21.6386 59.1948 21.1226 57.9582 21.1226 56.6687V34.7899Z",
    stroke: "#232C66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1226 44.6932C27.9591 48.3162 35.5079 50.2034 43.1634 50.2034C50.8188 50.2034 58.3677 48.3162 65.2042 44.6932",
    stroke: "#232C66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1122_50589",
    x1: 44.9999,
    y1: -22.5,
    x2: 44.9999,
    y2: 86.3265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B90D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242963"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1122_50589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompanyAccount);
export default __webpack_public_path__ + "static/media/icon-company-account.a809b53c009a7f659bb8fdb2b2ab43b0.svg";
export { ForwardRef as ReactComponent };